import type { IMessage } from '@/modules/Socket';

import { LogoIcon, StarIcon } from '@/icons';

import {
  AvatarBadge,
  StyledBadge,
  StyledBubbleHeader,
  StyledIconWrapper,
  StyledSenderName,
} from './BubbleHeaderStyles';

// Helpers
import { BUBBLE_HEADER_CONFIG } from '../../helpers';

export interface IBubbleHeaderProps {
  sender?: IMessage['sender'];
  label?: string;
  senderName: string;
  mainColor: string;
}

const BubbleHeader = ({ sender, label, senderName, mainColor }: IBubbleHeaderProps) => {
  const config = sender ? BUBBLE_HEADER_CONFIG[sender] : undefined;
  if (!config) return null;

  return (
    <StyledBubbleHeader>
      <StyledIconWrapper $primary={mainColor}>
        <LogoIcon />
        <AvatarBadge $primary={mainColor}>
          <StarIcon />
        </AvatarBadge>
      </StyledIconWrapper>
      <StyledSenderName>
        {config.getName({ label, senderName })}
        {config.badge && (
          <StyledBadge $primary={mainColor}>
            <StarIcon />
            {config.badge}
          </StyledBadge>
        )}
      </StyledSenderName>
    </StyledBubbleHeader>
  );
};

export default BubbleHeader;
